import { GET_CONDOMINIO, GET_CONDOMINI, CREA_CONDOMINIO, ATTIVA_DISATTIVA_CONDOMINIO, MODIFICA_CONDOMINIO, CHECK_LINK_REGISTRAZIONE_CONDOMINIO, ELIMINA_CONDOMINIO, GET_CONDOMINI_CONSIGLIERI, CONDOMINIO_ERROR } from '../actions/types';

const initialState = {
    condomini: [],
    condominio: null,
    consiglieri: [],
    loading: true
}

export default function auth (state = initialState, action){
    const { type, payload } = action;
    switch(type){
        case GET_CONDOMINIO:
        case ATTIVA_DISATTIVA_CONDOMINIO:
        case MODIFICA_CONDOMINIO:
        case CHECK_LINK_REGISTRAZIONE_CONDOMINIO:
            return {
                ...state,
                condominio: payload,
                loading: false
            };
        case GET_CONDOMINI:
            return {
                ...state,
                condomini: payload,
                loading: false
            };
        case CREA_CONDOMINIO:
            let arrayCondomini = [...state.condomini];
            arrayCondomini.push(payload);
            arrayCondomini.sort((a,b) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : ((b.nome.toLowerCase() > a.nome.toLowerCase()) ? -1 : 0)); 
            return {
                ...state,
                condomini: arrayCondomini,
                loading: false
            };
        case GET_CONDOMINI_CONSIGLIERI: 
        return {
            ...state,
            consiglieri: payload,
            loading: false
        };
        case ELIMINA_CONDOMINIO: 
                    let arrayCondominioElimina = [...state.condomini];
                    arrayCondominioElimina = arrayCondominioElimina.filter(condominio => condominio._id !== payload)
                    return {
                        ...state,
                        condomini: arrayCondominioElimina,
                        loading: false
                };
        case CONDOMINIO_ERROR:
            // Un errore (es. validazione fallita su modificaCondominio) non deve svuotare
            // i dati già caricati: altrimenti il form in modifica si resetta come se il
            // condominio non esistesse più, perdendo i valori originali (es. la tendina
            // "Cartella Dropbox" torna alla prima voce della lista invece di restare sul
            // valore corretto).
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}